var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.showPlayer)?_c('player',{ref:"player",attrs:{"code":_vm.currentCodeList,"isCodeFirstInit":_vm.isCodeFirstInit,"evenOrOdd":_vm.evenOrOdd,"typeNum":_vm.typeNum}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }